
import { placeToVisitApi, PlaceToVisitDto, PlaceToVisitRequest } from '@/api/placeToVisit'
import { Phone } from '@/types'
import countries, { getCountryLabel } from '@/utils/countries'
import isEmailValid from '@/utils/email'
import { isRequiredGenerator, maxLengthGenerator } from '@/utils/rules'
import { formatAddress } from '@/utils/addresses'
import AddressPropositions from '@/components/shared/AddressPropositions.vue'
import { AddressProposition } from '@/api/address'
import { AxiosResponse } from 'axios'
import { cloneDeep, isEqual } from 'lodash'
import Vue, { PropType } from 'vue'
import ConfirmCancelDialog from '@/components/ConfirmCancelDialog.vue'
import { handleAxiosException } from '@/api'

export default Vue.extend({
  components: { ConfirmCancelDialog, AddressPropositions },
  props: {
    value: {
      required: true,
      type: Boolean,
    },
    placeToVisit: Object as PropType<PlaceToVisitDto>,
  },
  data() {
    return {
      editing: false,
      error: '',
      valid: true,
      form: { address: {} } as PlaceToVisitRequest, // champs address existant pour eviter npe
      copyForm: { address: {} } as PlaceToVisitRequest,
      telInput: {} as Phone,
      countries,
      confirmCancelDialog: false,
      customerTypes: [
        { key: 'MAN', icon: 'mdi-account' },
        { key: 'COMPANY', icon: 'mdi-domain' },
      ],
    }
  },
  methods: {
    // FORMATTERS
    formatAddress,
    getCountryLabel,
    // RULES
    isRequiredGenerator,
    isEmailValid,
    maxLengthGenerator,
    // ACTIONS
    getFullAddress(form: PlaceToVisitRequest) {
      return `${form.address.address || ''} ${form.address.zip || ''} ${form.address.town || ''}`.replace('  ', ' ')
    },
    selectAddress(proposition: AddressProposition, form: PlaceToVisitRequest) {
      // eslint-disable-next-line no-param-reassign
      form.address.address = proposition.properties.name
      // eslint-disable-next-line no-param-reassign
      form.address.zip = proposition.properties.postcode
      // eslint-disable-next-line no-param-reassign
      form.address.town = proposition.properties.city
    },
    cancelEdit() {
      if (!isEqual(this.form, this.copyForm)) {
        this.confirmCancelDialog = true
      } else {
        this.close()
      }
    },
    confirmConfirmCancelEdit() {
      this.confirmCancelDialog = false
      this.close()
    },
    async saveEdit() {
      if ((this.$refs.form as HTMLFormElement).validate()) {
        this.editing = true
        this.error = ''
        try {
          if (this.placeToVisit) {
            await placeToVisitApi.update(this.placeToVisit.id, this.form)
            this.$emit('success', this.form)
          } else {
            const place = await placeToVisitApi.create(this.form)
            this.$emit('success', place)
          }
        } catch (err) {
          this.error = this.$t(handleAxiosException(err, (r: AxiosResponse) => r.data?.message ?? 'form.error.global_error')) as string
          this.editing = false
        }
      }
    },
    close() {
      this.$emit('input', false)
    },

    // PHONES
    isPhoneValid(phone: Phone) {
      return phone.valid || (phone.valid === undefined && phone.number?.length > 0)
    },
    handlePhoneNumberInput(item: Phone, number: string, object: { valid: boolean, number: { e164?: string, input: string } }) {
      // eslint-disable-next-line no-param-reassign
      item.valid = object.valid
      // eslint-disable-next-line no-param-reassign
      item.number = object.number.e164 || object.number.input
      this.form.phonenumber = item.number
    },
  },
  watch: {
    value(val) {
      if (val) {
        this.editing = false
        // on rajoute champs à vide pour que le check de cancel ne s'active pas si on compare vide et undefined
        this.form = cloneDeep(this.placeToVisit ?? { address: { country: 'FR', address: '', zip: '', town: '' }, phonenumber: '', name: '', fullName: '', email: '' } as PlaceToVisitRequest)
        this.copyForm = cloneDeep(this.form)
        this.valid = true
        // eslint-disable-next-line no-unused-expressions
        ;(this.$refs.form as HTMLFormElement)?.resetValidation()
        this.telInput = { number: this.form.phonenumber, display: this.form.phonenumber }
      }
    },
  },
})
